import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

const lightTheme = createTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                backgroundColor: 'white',
                color: '#252733',
                fontSize: '12px',
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '130%',
                boxShadow: '0px 4px 16px 0px rgba(30, 35, 75, 0.16)',
            },
            arrow: {
                color: 'white',
            },
        },
    },
});

const paddingTheme = createTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                backgroundColor: 'white',
                color: '#252733',
                fontSize: '10px',
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '120%',
                boxShadow:
                    '0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 32px 0px rgba(0, 0, 0, 0.16)',
                padding: '8px 12px',
                borderRadius: '6px',
            },
            arrow: {
                color: 'white',
            },
        },
    },
});

export const CustomTooltip = ({ children, title, position = 'top', variant = 'light' }) => {
    const mappingTheme = {
        light: lightTheme,
        padding: paddingTheme,
    };

    return (
        <ThemeProvider theme={mappingTheme[variant]}>
            <Tooltip
                title={title}
                // placement={position}
                PopperProps={{
                    modifiers: {
                        offset: {
                            enabled: true,
                            offset: '0, -10',
                        },
                    },
                }}
            >
                {children}
            </Tooltip>
        </ThemeProvider>
    );
};
